<template>
  <div class="editorial-threecolumn">
    <template v-for="(card, index) in handleResize()">
      <div
        v-if="
          card.cardType === 'video' &&
          ((!card.isVisibleOnMobile && !smallScreen) || (card.isVisibleOnMobile && smallScreen))
        "
        :key="index"
        class="editorial_video"
      >
        <span class="video-wrapper">
          <!-- //NOSONAR --><video
            id="video"
            :ref="'videobanner_' + index"
            autoplay
            muted
            loop
            playsinline
          >
            <source media="(min-width:1024px)" :src="card.videoContent.desktopVideoUrl" />
            <source :src="card.videoContent.mobileVideoUrl" />
          </video>

          <button id="play_button" @click="togglePlay(index)">
            <svg v-if="playing[index]" class="icon icon-stop">
              <use xlink:href="#stop"></use>
            </svg>
            <svg v-if="!playing[index]" class="icon icon-play">
              <use xlink:href="#play"></use>
            </svg></button
        ></span>
      </div>
      <div
        v-if="
          card.cardType === 'image' &&
          ((!card.isVisibleOnMobile && !smallScreen) || (card.isVisibleOnMobile && smallScreen))
        "
        :key="index"
        class="editorial_image"
      >
        <picture>
          <source
            :data-srcset="card.imageContent.mobileImageurl"
            media="(max-width:1023px)"
            :srcset="transparentPixel"
          />
          <img
            class="lazyload"
            :data-src="card.imageContent.desktopImageurl"
            :alt="card.imageContent.desktopImagealt"
            :src="transparentPixel"
          />
        </picture>
      </div>
      <div
        v-if="
          card.cardType === 'text' &&
          ((!card.isVisibleOnMobile && !smallScreen) || (card.isVisibleOnMobile && smallScreen))
        "
        :key="index"
        class="editorial_text"
        :class="card.textContent.contentAlignmentType"
        :style="{
          '--backgroundColor':
            card.textContent && card.textContent.contentBackgroundColor
              ? card.textContent.contentBackgroundColor
              : '#fff',
        }"
      >
        <h3 v-if="card.textContent.title" class="text_mainTitle">{{ card.textContent.title }}</h3>
        <h4 v-if="card.textContent.subTtitle" class="text_subTitle">
          {{ card.textContent.subTtitle }}
        </h4>
        <p v-if="card.textContent.description" class="text_description">
          {{ card.textContent.description }}
        </p>
        <a
          v-if="card.textContent.ctaText"
          class="text_link"
          target="_blank"
          :href="card.textContent.ctaLink"
          @click="triggerTagging(card.textContent.taggingAttributes)"
          >{{ card.textContent.ctaText }}</a
        >
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'editorial-three-column',

  props: {
    resultcard: {
      type: [Object, Array],
      default: () => [],
    },
  },
  data() {
    return {
      smallScreen: window.matchMedia('(max-width: 1030px)').matches,
      playing: [],
      transparentPixel:
        'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    };
  },
  mounted() {
    this.playing = this.resultcard.map((card) => card.cardType === 'video');
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize() {
      return this.resultcard;
    },
    togglePlay(index) {
      const videoRef = this.$refs['videobanner_' + index];
      const video = Array.isArray(videoRef) ? videoRef[0] : videoRef;
      if (video && typeof video.pause === 'function' && typeof video.play === 'function') {
        if (this.playing[index]) {
          video.pause();
        } else {
          video.play();
        }
        const updatedPlaying = this.playing.slice();
        updatedPlaying[index] = !updatedPlaying[index];
        this.playing = updatedPlaying;
      }
    },
    toValidJsonString(str) {
      const htmlDecoded = str.replace(/&#39;/g, "'");
      const quoteKeys = htmlDecoded.replace(/([{,]\s*)(\w+)\s*:/g, '$1"$2":');
      const doubleQuoted = quoteKeys.replace(/'/g, '"');
      return doubleQuoted;
    },
    triggerTagging(rawData) {
      const jsonStr = this.toValidJsonString(rawData);
      const data = JSON.parse(jsonStr);

      dataLayer.push(data);
    },
  },
};
</script>
